import React from 'react';
import { Icon, Text, useIsMobile } from '@amzn/storm-ui';
import styled, { css } from 'styled-components';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';
import { useIsRTL } from 'src/commons/hooks';

export const ErrorLoadingAccountsContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  padding: ${({ theme, isMobile }) =>
    `${theme.spacing.base} ${theme.spacing.micro} ${
      isMobile ? '2px' : '16px'
    }`};
  justify-content: center;
`;

const StyledText = styled(Text)`
  display: flex;
`;

const WarningIcon = styled(Icon)<{ isRtl: boolean }>`
  color: ${({ theme }) => theme.palette.mango};
  ${({ isRtl }) =>
    isRtl
      ? css`
          margin-left: 5px;
        `
      : css`
          margin-right: 5px;
        `}
`;

export const ErrorLoadingAccountsMessage: React.VFC = () => {
  const bundle = useAccountDropdownBundle();
  const isRtl = useIsRTL();
  const isMobile = useIsMobile();

  return (
    <ErrorLoadingAccountsContainer isMobile={isMobile ?? false}>
      <StyledText textColor="secondary" fontSize="small">
        <WarningIcon type="exclamation-triangle" isRtl={isRtl} />
        {bundle.getMessage('account-dropdown-error-loading-accounts')}
      </StyledText>
    </ErrorLoadingAccountsContainer>
  );
};
